import { selectPartner360Data } from 'legacy/lut/features/partner360/configuration'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ESP_TRANSLATION_KEYS as KEYS } from '../../configs/translations'
import { TEspRequestType } from '../../model/types'
import { EspRequestForm } from '../espRequestForm/EspRequestForm'
import { EspRequestFormFooter } from '../espRequestForm/EspRequestFormFooter'

import styles from './EspRequestFormModal.module.scss'

interface IEspRequestFormContentProps {
  partnerId: string
  mode: TEspRequestType
}

const EspRequestFormContent = ({ partnerId, mode }: IEspRequestFormContentProps) => (
  <EspRequestForm partnerId={partnerId} mode={mode} />
)

interface IEspRequestFormModalProps {
  show: boolean
  partnerId: string
  mode: TEspRequestType
  onClose: () => void
}

/**
 * The enrollment / sponsor-change request form in a modal. The title lives in the
 * modal's fixed header and the buttons in its fixed footer, so only the form fields
 * scroll; content and footer communicate through the shared form key.
 */
export const EspRequestFormModal: FC<IEspRequestFormModalProps> = ({
  show,
  partnerId,
  mode,
  onClose,
}) => {
  const { partnerName } = useSelector(selectPartner360Data)

  const titleReplaceParams = useMemo(
    () => [{ key: '{partner_name}', value: partnerName }],
    [partnerName]
  )

  return (
    <ModalDialog<IEspRequestFormContentProps>
      show={show}
      onClose={onClose}
      size="sm"
      classes={{
        header: styles.header,
        footer: styles.footer,
        body: styles.body,
        window: styles.window,
      }}
      header={() => (
        <div className={styles.title}>
          <Translation
            text={mode === 'change' ? KEYS.requestForm.changeTitle : KEYS.requestForm.enrollTitle}
            replaceParams={titleReplaceParams}
            span
          />
        </div>
      )}
      content={EspRequestFormContent}
      contentProps={{ partnerId, mode }}
      footer={() => <EspRequestFormFooter partnerId={partnerId} mode={mode} onClose={onClose} />}
      closeOnOutsideClick={false}
    />
  )
}

EspRequestFormModal.displayName = 'EspRequestFormModal'
